$('#button-scroll').on('click', function () {
    var smooth = [$('a.smooth'), 100, 750];
    $('html, body').animate({
        scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top - smooth[1]
    }, smooth[2]);
    return false;
});

// Change the state of the input field according to the tab
$('#input-radio-box').on('change', function (e) {
    if (e.target.value === '1') {
        $('#field-pin').addClass('hide');
    } else {
        $('#field-pin').removeClass('hide');
    }
});

$(document).ready(function () {
    $('#ctaButtonsContainer').removeAttr('style');
    $('.cta-gift-card-balance .button').eq(0).addClass('button--primary');
    $('.cta-gift-card-balance .button').eq(1).addClass('button--secondary');
    $('.cc-contentBox, #cnt-carta-reso').removeClass('content-box-choose-gift');
    $('#cnt-gift-cards').insertAfter('#form-gift-card');
    $('#button-scroll').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#balance-gift').offset().top - $('.cc-mainHeader-container').height()
        }, 1000, 'linear');
    });

    $('body').on('click', '.js-myAccountGiftCard-checkAnotherCard', e => {
        $('[name="inputCode"]').val('');
        $('[name="inputPin"]').val('');
        $('.wrapper-content-slot').addClass('hiddenGiftCard');
        $('html, body').animate({ scrollTop: $('.cc-myAccountGiftCard').position().top - $('.js-mainHeader-container').height() }, 'slow');
    });
});
